import React from "react";
import PropTypes from "prop-types";
import { Bar as HorizontalBar } from "react-chartjs-2";
import "chartjs-plugin-datalabels";
import { FormatAsDollars } from "./../../../utils/Helpers/Format";
import { useIntl } from "react-intl";
import "../../../utils/chartSetup";

const CostToOwnComparisonChart = ({
     carNames,
     carsCosts,
     displayEvCostBreakdownOption,
     displayEvCostBreakdown,
     comparison,
}) => {
     let chartData = {};

     const intl = useIntl();

     chartData = {
          labels: carNames,
          datasets: [
               {
                    label: intl.formatMessage({
                         id: "graph.costOfOwnership.chart.vehicle",
                         defaultMessage: "Vehicle net Incentives, Resale",
                    }),
                    backgroundColor: `#${process.env.REACT_APP_COMPONENTS_COST_TO_OWN_COMPARISION_CHART_BAR_COLOR_NET}`,
                    data: carsCosts.map((carCost) => {
                         return Math.round(carCost.vehicle.total);
                    }),
                    barPercentage: 0.5,
                    categoryPercentage: 1,
               },
               {
                    label: intl.formatMessage({
                         id: "graph.costOfOwnership.chart.electricity",
                         defaultMessage: "Electricity",
                    }),
                    backgroundColor: `#${process.env.REACT_APP_COMPONENTS_COST_TO_OWN_COMPARISION_CHART_BAR_COLOR_ELECTRICITY}`,
                    data: carsCosts.map((carCost) => {
                         return Math.round(carCost.electricity.total);
                    }),
                    barPercentage: 0.5,
                    categoryPercentage: 1,
               },
               {
                    label: intl.formatMessage({
                         id: "graph.costOfOwnership.chart.gasoline",
                         defaultMessage: "Gasoline",
                    }),
                    backgroundColor: `#${process.env.REACT_APP_COMPONENTS_COST_TO_OWN_COMPARISION_CHART_BAR_COLOR_GASOLINE}`,
                    data: carsCosts.map((carCost) => {
                         return Math.round(carCost.gasoline.total);
                    }),
                    barPercentage: 0.5,
                    categoryPercentage: 1,
               },
               {
                    label: intl.formatMessage({
                         id: "graph.costOfOwnership.chart.maintenance",
                         defaultMessage: "Maintenance",
                    }),
                    backgroundColor: `#${process.env.REACT_APP_COMPONENTS_COST_TO_OWN_COMPARISION_CHART_BAR_COLOR_MAINTENANCE}`,
                    data: carsCosts.map((carCost) => {
                         return Math.round(carCost.maintenance.total);
                    }),
                    barPercentage: 0.5,
                    categoryPercentage: 1,
               },
               {
                    label: intl.formatMessage({
                         id: "graph.costOfOwnership.chart.insurance",
                         defaultMessage: "Insurance",
                    }),
                    backgroundColor: `#${process.env.REACT_APP_COMPONENTS_COST_TO_OWN_COMPARISION_CHART_BAR_COLOR_INSURANCE}`,
                    data: carsCosts.map((carCost) => {
                         return Math.round(carCost.insurance.total);
                    }),
                    barPercentage: 0.5,
                    categoryPercentage: 1,
               },
          ],
     };

     const options = {
          indexAxis: "y",
          maintainAspectRatio: false,
          animation: {
               duration: 0,
          },
          scales: {
               x: {
                    stacked: true,
                    ticks: {
                         callback: function (value) {
                              value = FormatAsDollars(value);
                              return value;
                         },
                         beginAtZero: true,
                    },
               },
               y: {
                    stacked: true,
                    ticks: {
                         font: {
                              weight: 700,
                         },
                    },
               },
          },
          layout: {
               padding: {
                    right: 75,
               },
          },
          plugins: {
               legend: {
                    position: "bottom",
                    onClick: function (e) {
                         e.stopPropagation();
                    },
                    display: true,
               },
               datalabels: {
                    formatter: (value, ctx) => {
                         let datasets = ctx.chart.data.datasets;
                         if (ctx.datasetIndex === datasets.length - 1) {
                              let sum = 0;
                              datasets.forEach((dataset) => {
                                   sum += dataset.data[ctx.dataIndex];
                              });
                              return FormatAsDollars(sum);
                         } else {
                              return "";
                         }
                    },
                    align: "end",
                    anchor: "end",
                    color: "#333333",
                    font: {
                         weight: 700,
                    },
               },
               tooltip: {
                    callbacks: {
                         label: function (tooltipItem) {
                              const dataset = tooltipItem.dataset;
                              const value = dataset.data[tooltipItem.dataIndex];
                              const label = dataset.label || "";
                              return `${label}: ${FormatAsDollars(value)}`;
                         },
                         title: function (tooltipItems) {
                              const label = tooltipItems[0].label;
                              return `${label}`;
                         },
                    },
               },
          },
     };

     return <HorizontalBar data={chartData} height={comparison ? 312 : 212} type="horizontalBar" options={options} />;
};

export default CostToOwnComparisonChart;

CostToOwnComparisonChart.propTypes = {
     carNames: PropTypes.array,
     carCosts: PropTypes.array,
     displayEvCostBreakdownOption: PropTypes.bool,
     displayEvCostBreakdown: PropTypes.bool,
     displayFuelOnly: PropTypes.bool,
};
